module.exports = __webpack_public_path__ + "workspace/static/img/externalIDPThree.ddc06eb.png";